<template>
    <div class="admin__popup">
        <admin-campaigns-pop-up v-if="campaignPopUpFlag" :campaign="activeCampaign" @closePopup="campaignHidePopup"></admin-campaigns-pop-up>
        <div class="campaign__popup" v-if="!campaignPopUpFlag">

            <div class="control-btn-container">
                <div class="btn" @click="saveProfile" :class="{'disabled-btn': activeRequest}">
                    <svg v-if="!activeRequest" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-2">
                        <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                    </svg>
                    <clip-loader color="#2EA3FF" size="15px" :loading="activeRequest" />
                    <p>{{ activeRequest ? 'Saving...' : 'Save Profile' }}</p>
                </div>

                <div class="btn" @click="$emit('closePopup',updatedUser)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </div>
            </div>

            <!-- Header div -->
            <div class="popup__header">
                <p>{{advertiserInfo.firstname}} {{advertiserInfo.surname}}</p>
                <p>ID: {{advertiser.id}}</p>
                <span>ACTIVE</span>
            </div>

            <!-- Advertiser info -->
            <div class="advertiser__info box__container box-shadow flex col">
                <p class="header">Advertiser Information</p>

                <div class="input__container flex col flex-wrap">
                    <div class="input__pair">
                        <p>First Name</p>
                        <input type="text" v-model="advertiserInfo.firstname" />
                    </div>

                    <div class="input__pair">
                        <p>Last Name</p>
                        <input type="text" v-model="advertiserInfo.surname" />
                    </div>

                    <div class="input__pair">
                        <p>Email</p>
                        <input type="email" v-model="advertiserInfo.email" />
                    </div>

                    <div class="input__pair">
                        <p>Phone Number</p>
                        <input type="text" v-model="advertiserInfo.phone" />
                    </div>

                    <div class="input__pair">
                        <p>Company</p>
                        <input type="text" v-model="advertiserInfo.company" />
                    </div>

                    <div class="input__pair">
                        <p>Company Website</p>
                        <input type="text" />
                    </div>
                </div>

                <div class="terms__container">
                    <div>
                        <input type="checkbox" name="notifications" v-model="advertiserInfo.ADWAY_notifications" />
                        <label for="notifications">I want to receive Adway's campaign notifications</label>
                    </div>
                </div>
            </div>

            <!-- Campaign information -->
            <div class="campaign__information box__container box-shadow advertiser__filter__data">
                <div class="header">
                    <p>Campaign information</p>
                </div>

                <div class="filters__container">
                    <p class="header">FILTER</p>

                    <div class="filters__row flex row">
                     <div class="filter__section">

                            <v-date-picker mode="single" :masks="{ input: ['MM-DD-YYYY']}" :input-props='{class: "datepicker"}' v-model="filters.start_date" />
                            <el-time-picker
                            class="time-pick"
                                v-model="filters.start_time"
                                selectableRange="00:00 - 12:59"
                                format="hh:mm A"
                                value-format="HH:mm">
                            </el-time-picker>
                    </div>
                     <div class="filter__section">
                            <v-date-picker mode="single" :masks="{ input: ['MM-DD-YYYY']}" :input-props='{class: "datepicker"}' v-model="filters.end_date" />
                            <el-time-picker
                                class="time-pick"
                                v-model="filters.end_time"
                                selectableRange="00:00 - 12:59"
                                format="hh:mm A"
                                value-format="HH:mm">
                            </el-time-picker>

                        <p class="apply-btn">Apply</p>
                    </div></div>
                </div>

                <div class="list__container">

                    <div class="list__headers" v-if="advertiserInfo.campaigns.length > 0">
                        <p>Campaign</p>
                        <p class="w-20">Start</p>
                        <p class="w-20">End</p>
                        <p class="w-15">Campaign ID</p>
                        <p class="w-15">Status</p>
                    </div>

                    <div class="list__item" v-for="campaign in paginatedCampaigns" v-bind:key="campaign.name">
                        <div class="flex flex-ac">
                            <p>{{ campaign.name }}</p>
                            <span class="rounded" :class="{'active__background': campaign.active === 'Y', 'inactive__background': campaign.active === 'N'}">{{ campaign.active === 'Y' ? 'Activate' : 'Stop' }}</span>
                        </div>

                        <div class="w-20">
                            <p>{{ slashDate(campaign.start) }}</p>
                        </div>

                        <div class="w-20">
                            <p>{{ slashDate(campaign.end) }}</p>
                        </div>

                        <div class="w-15" @click="campaignPopUp(campaign)" style="cursor: pointer">
                            <p>{{ campaign.id }}</p>
                        </div>

                        <div class="w-15">
                            <p class="status__p" :class="{'active__background': campaign.active === 'Y', 'inactive__background': campaign.active === 'N'}"></p>
                        </div>
                    </div>

                    <paginate
                        v-if="advertiserInfo.campaigns.length > 0"
                        :page-count="campaignTotal"
                        :container-class="'paginationContainer'"
                        :active-class="'paginationActive'"
                        :click-handler="campaignPaginate">
                    </paginate>

                    <p class="empty__pagination" v-if="advertiserInfo.campaigns.length === 0">No campaigns found for this advertiser</p>
                </div>

                <div class="map__container">
                    <GmapMap
                        :center="{lat: lat, lng: lon}"
                        :zoom="10"
                        ref="heatMap"
                        :options="{mapTypeControl: false, streetViewControl: false, styles, zoomControl: false, fullscreenControl: true, gestureHandling: 'cooperative'}"
                        map-type-id="terrain"
                        style="width: 100%; margin: 15px 0 15px 0; height: 300px"
                    >
                        <GmapPolygon
                            v-for="(polygon, index) in polygons"
                            v-bind:key="index"
                            :path.sync="polygon"
                            :options="{strokeColor: '#102130', strokeWeight: 2, fillColor: 'rgb(223, 242, 255)', fillOpacity: .5}"
                            />
                    </GmapMap>
                </div>
            </div>

            <div class="campaign__information box__container box-shadow" :class="{'financial__data':advertiserInfo.financials.length >0, 'fin-data':advertiserInfo.financials.length == 0}">
                <div class="header">
                    <p>FINANCIAL DATA</p>
                </div>

                <div class="list__container">
                    <div class="flex">
                        <div class="sum__container">
                            <p>Balance: <span> ${{ parseFloat(advertiserInfo.balance || 0).toLocaleString() }}</span></p>
                        </div>

                        <div class="sum__container">
                            <p>LTV: <span> ${{ parseFloat(advertiserInfo.LTV || 0).toLocaleString() }}</span></p>
                        </div>
                    </div>

                    <div class="list__headers" v-if="advertiserInfo.financials.length > 0">
                        <p class="transaction__col">TRANSACTION</p>
                        <p class="amount__col">AMOUNT</p>
                        <p class="date__col">DATE</p>
                    </div>

                    <div class="list__body">
                        <div class="list__item" v-for="data in paginatedFinancials" v-bind:key="data.type">
                            <p class="transaction__col">{{ data.type }}</p>
                            <p class="amount__col">${{ parseFloat(data.amount || 0).toLocaleString() }}</p>
                            <p class="date__col">{{ customMonthFormatter(data.created) }}</p>
                        </div>
                    </div>
                </div>

                <paginate
                    v-if="advertiserInfo.financials.length > 0"
                    :page-count="financialsTotal"
                    :container-class="'paginationContainer'"
                    :active-class="'paginationActive'"
                    :click-handler="financialsPaginate">
                </paginate>

                <p class="empty__pagination" v-if="advertiserInfo.financials.length === 0">No financials found for this advertiser</p>
            </div>
        </div>
    </div>
</template>

<script>
import TimePicker from '@components/partials/TimePicker.vue'
import Datepicker from 'vuejs-datepicker'
import {gmapApi} from 'vue2-google-maps'
import heatCoords from '@utils/heatMapCoords.js'
import styles from '@utils/mapStylesDark.js'
import {paginateList, paginationTotal} from '@utils/pagination.js'
import $ from 'jquery'
import moment from 'moment'
import toast from '@utils/toast'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import AdminCampaignsPopUp from './AdminCampaignsPopUp.vue'
export default {
    name: 'AdvertiserPopUp',
    props: {
        advertiser: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data: function () {
        return {
            lat: 55.9352001,
            lon: -4.7766924,
            distance: 10000,
            styles,
            campaignStats: null,
            statsCoordinates: null,
            map: null,
            advertiserInfo: {
                campaigns: [],
                financials: []
            },
            campaignPageNumber: 1,
            campaignTotal: 1,
            financialsPageNumber: 1,
            financialsTotal: 1,
            filters: {
                start_date: new Date(moment().subtract(1, 'months').format('MM-DD-YYYY')),
                end_date: new Date(moment().format('MM-DD-YYYY')),
                start_time: '00:00',
                end_time: '00:00'
            },
            activeRequest: false,
            bounds: null,
            polygons: [],
            campaignPopUpFlag: false,
            perPage:5,
            updatedUser:{}
        }
    },
    methods: {
        getStats() {
            var url = '/admin/get/advertiser'
            var body = {
                data: {
                    advertiser_id: this.advertiser.id,
                    from: null,
                    till: null
                }
            }

            this.request(url, 'POST', body).then(response=>{
                if (response.code === 0) {
                    this.advertiserInfo = response.data

                    var campaignsLength = this.advertiserInfo.campaigns.length
                    var financialsLength = this.advertiserInfo.financials.length

                    this.campaignTotal = paginationTotal(campaignsLength,this.perPage)
                    this.financialsTotal = paginationTotal(financialsLength,this.perPage)
                    this.checkMap()
                } else {
                    toast.errorMessage(response.message)
                    if (response.code === 112) {
                        this.checkTokenConditions(this.getStats)
                    }
                }
            })
        },
        slashDate(date) {
            return moment(date).format('MM/DD/YYYY')
        },
        campaignPaginate(number){
            this.campaignPageNumber = number
        },
        financialsPaginate(number){
            this.financialsPageNumber = number
        },
        startTimeChange (time) {
            this.filters.start_time = time
        },
        endTimeChange (time) {
            this.filters.end_time = time
        },
        saveProfile(){
            if(this.activeRequest){
                return
            }

            var url = '/admin/set/advertiser'
            var body = {
                data: {
                    advertiser_id: this.advertiser.id,
                    ...this.advertiserInfo
                }
            }
            this.activeRequest = true
            this.request(url, 'POST', body).then(response=>{
                if (response.code === 0) {
                    toast.successMessage('Advertiser profile saved')
                    this.updatedUser=body;

                    this.activeRequest = false
                } else {
                    toast.errorMessage(response.message)
                    if (response.code === 112) {
                        this.checkTokenConditions(this.saveProfile)
                    }
                }
            }).catch(error=>{
                toast.errorMessage('Something happened')
                this.activeRequest = false
            })
        },
        checkMap() {
            if(this.advertiserInfo.campaign_boundaries && this.advertiserInfo.campaign_boundaries.coordinates){
                this.bounds = new this.google.maps.LatLngBounds()
                this.extractCoordinates(this.advertiserInfo.campaign_boundaries.coordinates)
                this.map.fitBounds(this.bounds)
            }
        },
        campaignPopUp (campaign) {
            this.campaignPopUpFlag = true
            this.activeCampaign = campaign
        },
        campaignHidePopup () {
            this.campaignPopUpFlag = false
        },
        // Filter a given array of coordinates to create array suitable for drawing polygon
        extractCoordinates (coordinates, loop=false) {
            if(!loop){
                this.polygons = []
            }

            if(typeof coordinates[0][0] === "number") {
                var polygon = []
                coordinates.map(pair=>{
                    let latLng = new this.google.maps.LatLng(pair[1], pair[0])
                    this.bounds.extend(latLng)
                    polygon.push({ lat: pair[1], lng: pair[0] })
                })
                this.polygons.push(polygon)
            } else {
                coordinates.map(pair=>{
                    this.extractCoordinates(pair, true)
                })
            }
        },
        checkTokenConditions (callback) {
            try{
                var expiresDate = new Date(this.token.expires)
            } catch (err) {
                this.$router.push('/login')
            }
            var now = new Date()
            if (expiresDate <= now) {
                this.store.commit('setToken', {})
                this.$router.push('/login')
            } else {
                var body = {
                    code: '',
                    refresh_token: this.token.refresh_token
                }
                this.request('/refresh/token', 'POST', body).then((response) => {
                if (response.code === 0 ) {
                    store.commit('setToken', response.data[0])
                    store.commit('setDriver', response.data[0].driver)
                    callback()
                } else if (response.code === 112) {
                    this.store.commit('setToken', {})
                    this.$router.push('/login')
                }
                }).catch((error) => {
                })
            }
            var token = this.token
            token.redirect = false
            this.store.commit('setToken', token)
        }
    },
    mounted(){
        let self = this;
        this.getStats();

        this.$refs['heatMap'].$mapPromise.then((map) => {
            self.map = map
        })

        setTimeout(() => {
            var mapElement = document.getElementsByClassName("vue-map-container")[0]
            mapElement.setAttribute("style", "height: 302px; margin: 15px 0px; width: 100%;")
        }, 800)
    },
    components: {
        Datepicker,
        TimePicker,
        ClipLoader,
        AdminCampaignsPopUp
    },
    computed: {
        google: gmapApi,
        paginatedCampaigns: function() {
            return paginateList(this.advertiserInfo.campaigns, this.campaignPageNumber,this.perPage)
        },
        paginatedFinancials: function() {
            return paginateList(this.advertiserInfo.financials, this.financialsPageNumber,this.perPage)
        }
    }
}
</script>

<style scoped>
@import '../../style/admin.css';
</style>
